<!-- eslint-disable import/no-unresolved -->
<template>
  <div v-if="userProfile.profile">
    <validation-observer ref="generalTab">
      <b-card id="personalInfo-section">
        <b-form>
          <h4 class="mb-2">
            {{ $t('residency_introduction') }}
          </h4>
          <b-row>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                label-for="residency-country"
                :label="$t('residency_country')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('residency_country')"
                  vid="residency-country"
                  rules="required"
                >
                  <v-select
                    id="residency-country"
                    v-model="userProfile.residency"
                    :dir="!$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="formsListData.countries"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    :placeholder="$t('residency_country')"
                    autocomplete="nope"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                label-for="citizenship-country"
                :label="$t('citizenship_country')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('citizenship_country')"
                  vid="citizenship-country"
                  rules="required"
                >
                  <v-select
                    id="citizenship-country"
                    v-model="userProfile.citizenship"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    :options="formsListData.countries"
                    :placeholder="$t('citizenship_country')"
                    autocomplete="nope"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                :label="$t('city')"
                label-for="city"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('city')"
                  vid="city"
                  rules="required"
                >
                  <b-form-input
                    v-model="userProfile.city"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    :placeholder="$t('city')"
                    name="city"
                    @keypress="onlyAlpha($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <!-- allProfileInfo.form -->
        <b-form class="mt-2">
          <h4 class="mb-2">
            {{ $t('personal_information') }}
          </h4>
          <b-row>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                :label="$t('first_name')"
                label-for="FirstName"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('first_name')"
                  vid="first_name"
                  rules="required"
                >
                  <b-form-input
                    v-model="userProfile.first_name"
                    :placeholder="$t('first_name')"
                    name="FirstName"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    autocomplete="nope"
                    @keypress="onlyAlpha($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ First Name -->
            <!-- Last Name -->
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                :label="$t('last_name')"
                label-for="LastName"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('last_name')"
                  vid="last_name"
                  rules="required"
                >
                  <b-form-input
                    v-model="userProfile.last_name"
                    name="LastName"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    :placeholder="$t('last_name')"
                    autocomplete="nope"
                    @keypress="onlyAlpha($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ First Name -->
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                label-for="example-datepicker"
                :label="$t('birth_date')"
              >
                <validation-provider
                  v-slot="{ errors }"
                  ref="birthRef"
                  :name="$t('birth_date')"
                  vid="birth_date"
                  rules="required"
                >
                  <date-picker
                    id="birth_date"
                    v-model="convertedBirthdate"
                    :color="getColor('primary')"
                    :locale="citizenshipName === 'Iran' ? 'fa' : 'en'"
                    type="date"
                    :disabled="!$store.state.profile.profileInfo.edit_profile || !citizenshipName"
                    :placeholder="$t('birth_date')"
                    :initial-value="jalaali().format('jYYYY/jMM/jDD')"
                    :max="moment().format('YYYY-MM-DD')"
                    :min="moment().subtract(100, 'years').format('YYYY-MM-DD')"
                    auto-submit
                    format="YYYY-MM-DD"
                    :display-format="citizenshipName === 'Iran' ? 'jDD/jMM/jYYYY' : 'DD-MM-YYYY'"
                  />
                  <!-- citizenshipName === 'Iran' ?  -->
                  <small
                    class="text-danger"
                  >{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                label-for="gender"
                :label="$t('gender')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('gender')"
                  vid="Gender"
                  rules="required"
                >
                  <v-select
                    id="v"
                    v-model="userProfile.profile.gender"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    label="value"
                    :options="formsListData.gender"
                    :disabled="!$store.state.profile.profileInfo.edit_profile"
                    :placeholder="$t('gender')"
                    autocomplete="nope"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Email -->
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                :label="$t('email')"
                label-for="account-e-mail"
              >
                <b-form-input
                  v-model="userProfile.email"
                  name="email"
                  :placeholder="$t('email')"
                  :disabled="true"
                  autocomplete="nope"
                />

              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button
                v-if="!pending"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mr-1"
                :disabled="!$store.state.profile.profileInfo.edit_profile"
                @click="submit"
              >
                {{ $t('save_changes') }}
              </b-button>

              <b-button
                v-if="pending"
                variant="primary"
                class="mt-2 mr-1"
                disabled
              >
                <b-spinner
                  small
                  type="grow"
                />
                <span>{{ $t('loading') }}</span>
              </b-button>
            </b-col>
            <!--/ birth date -->
          </b-row>
        </b-form>
      </b-card>
    </validation-observer>
    <ValidationObserver ref="mobileActivationForm">
      <b-card :title="$t('mobile_number')">
        <b-alert
          class="p-2 mt-2"
          style="height: 100%;position: relative;"
          show
          variant="warning"
        >
          <span> {{ $t('add-mobile-section-change-message') }}</span>
        </b-alert>
        <b-form class="mt-2">

          <p style="margin-right: 3px;">
            {{ $t('guide') }} : {{ $t('guide-desc') }}
          </p>
          <b-row>
            <b-col
              md
              sm="12"
            >
              <b-form-group
                label-for="mobile-country-code"
                :label="$t('mobile_country_code')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('mobile_country_code')"
                  vid="mobile_country_code"
                  rules="required"
                >
                  <v-select
                    id="mobile-country-code"
                    v-model="mobile_country_code"
                    label="precode"
                    :filter-by="myFilter"
                    :options="formsListData.pre_country_code"
                    :placeholder="$t('mobile_country_code')"
                    autocomplete="nope"
                    :disabled="$store.state.profile.profileInfo.mobile_is_verify"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                  >
                    <template
                      slot="option"
                      slot-scope="option"
                      class="w-100 text-left"
                    >
                      <div
                        dir="ltr"
                        class="w-100 d-flex "
                      >
                        <img
                          :src="option.image"
                          class="language-image"
                        >
                        &nbsp;
                        <span class="select d-block">+{{ option.precode }}</span>
                        <span class=" d-block">({{ option.name }})</span>
                      </div>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col
              md
              sm="12"
            >
              <b-form-group
                label-for="mobile-number"
                :label="$t('mobile_number')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('mobile_number')"
                  vid="phone"
                  rules="required|noZeroStater"
                >
                  <b-form-input
                    id="mobile-number"
                    v-model="mobile_number"
                    class="form-control"
                    :placeholder="$t('mobile_number')"
                    autocomplete="nope"
                    minlength="3"
                    maxlength="15"
                    :disabled="$store.state.profile.profileInfo.mobile_is_verify"
                    @keypress="onlyNumbers($event)"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="auto"
              sm="12"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="primary"
                class="mt-2 mr-1 px-3"
                :disabled="$store.state.profile.profileInfo.mobile_is_verify"
                @click="SendCode"
              >
                <div v-if="!codePending">
                  {{ $t('send_code') }}
                </div>
                <div v-else>
                  <b-spinner
                    small
                    type="grow"
                  />
                  <span>{{ $t('loading') }}</span>
                </div>
              </b-button>
            </b-col>
          </b-row>
          <b-row
            v-if="($store.state.profile.profileInfo.mobile && !$store.state.profile.profileInfo.mobile_is_verify) && show"
            class="d-flex justify-content-center mt-3 mt-xl-0"
          >
            <b-col
              cols="12"
              class="mt-2"
            >
              <p class="text-success h5">
                {{ $t('input_received_otpcode_here', {
                  phone: `${$store.state.profile.profileInfo.mobile_country_code}${$store.state.profile.profileInfo.mobile}` })
                }}
              </p>
            </b-col>
            <b-col
              md
              sm="12"
            >
              <b-form-group
                label-for="receive-code"
                :label="$t('receive_code')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('receive_code')"
                  vid="receive-code"
                  rules="required"
                >
                  <b-form-input
                    id="receive-code"
                    ref="receive_code"
                    v-model="receive_code"
                    class="form-control"
                    :placeholder="$t('receive_code_placeholder')"
                    autocomplete="nope"
                    minlength="3"
                    maxlength="15"
                    @keypress="onlyNumbers($event)"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col
              md="auto"
              sm="12"
            >
              <b-button
                block
                variant="primary"
                class="mt-2 mr-1 px-3"
                @click="RegisterCode"
              >
                <div v-if="!registerPending">
                  {{ $t('code_registration') }}
                </div>
                <div v-else>
                  <b-spinner
                    small
                    type="grow"
                  />
                  <span>{{ $t('loading') }}</span>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>
import General from '@/views/logics/profile/General'

export default {
  mixins: [General],
}
</script>
<style>
.select {
  margin-right: 5px;
}
</style>
